import { Link } from 'react-router-dom'
import { Actions, Content, Message, SliderImage, SliderImageWrapper, StyledButton, Title, TitleHighlight, Wrapper } from './styles'

export default function Slide3() {
  return (
    <Wrapper>
      <Content>
        <Title variant="h1">
          <TitleHighlight>Share your travels</TitleHighlight> with the group
        </Title>
        <Message>
          New Group Buckets lets you and your travel friends share every adventure together. No more texting individual pics or Air Dropping. Create
          your Group Bucket, invite your friends and share your amazing memories back and forth.
        </Message>
        <Actions>
          <StyledButton color="inherit" component={Link} data-test="carousel-share-signup" to="auth/register" variant="outlined">
            Try it today!
          </StyledButton>
        </Actions>
      </Content>
      <SliderImageWrapper>
        <picture>
          <SliderImage
            sizes="(max-width: 1405px) 100vw, 1405px"
            srcSet="
              //content.photobucket.com/img/homepage/homepage-slider-travel-0701-w200.webp 200w,
              //content.photobucket.com/img/homepage/homepage-slider-travel-0701-w608.webp 608w,
              //content.photobucket.com/img/homepage/homepage-slider-travel-0701-w886.webp 886w,
              //content.photobucket.com/img/homepage/homepage-slider-travel-0701-w1099.webp 1099w,
              //content.photobucket.com/img/homepage/homepage-slider-travel-0701-w1405.webp 1405w"
            src="//content.photobucket.com/img/homepage/homepage-slider-travel-0701-w1405.webp"
            alt="Friends taking and sharing a selfie on Photobucket with Group Buckets!"
          />
        </picture>
      </SliderImageWrapper>
    </Wrapper>
  )
}
